export default {
  nav_brand: 'AllChinaBuy Spreadsheet',
  nav_home: 'Accueil',
  nav_categories: 'Catégories',
  nav_guides: 'Guide d\'Achat',
  nav_faq: 'FAQ',
  lang_switch: 'Langue',
  lang_en: 'English',
  lang_fr: 'Français',
  lang_de: 'Deutsch',
  lang_da: 'Dansk',

  hero_h1: 'AllChinaBuy Spreadsheet — Trouvez des Produits, Vendeurs et Guides d\'Achat',
  hero_subtitle: 'Découvrez les dernières ressources AllChinaBuy, les produits populaires, les informations sur les vendeurs de confiance, les conseils de contrôle qualité, les guides d\'expédition et les conseils pratiques — tout en un seul endroit.',
  hero_cta_primary: 'Explorer AllChinaBuy Spreadsheet',
  hero_cta_secondary: 'Parcourir les Trouvailles Populaires',
  hero_trust: 'Ressources mises à jour • Informations indépendantes • Guides accessibles',
  hero_support_title: 'Vous cherchez un AllChinaBuy Spreadsheet?',
  hero_support_desc: 'Trouvez des listes de produits utiles, des ressources vendeurs, des guides par catégorie, des informations de contrôle qualité, des conseils d\'expédition et des astuces d\'achat AllChinaBuy sans chercher sur des dizaines de sites.',

  whatis_title: 'Qu\'est-ce que AllChinaBuy Spreadsheet?',
  whatis_desc: 'Un AllChinaBuy Spreadsheet est une collection organisée de liens produits, d\'informations vendeurs, de guides d\'achat et de conseils de contrôle qualité compilés pour aider les acheteurs à trouver les meilleurs articles via la plateforme AllChinaBuy.',
  step_find: 'Trouver',
  step_find_desc: 'Parcourez des listes de produits et des annuaires de vendeurs organisés par catégorie.',
  step_research: 'Rechercher',
  step_research_desc: 'Comparez les vendeurs, vérifiez les photos QC et examinez les options d\'expédition avant d\'acheter.',
  step_buy: 'Acheter',
  step_buy_desc: 'Commandez en toute confiance avec des ressources vérifiées et des guides d\'achat pratiques.',

  categories_title: 'Catégories Populaires du Spreadsheet',
  categories_subtitle: 'Explorez des catégories de produits organisées pour trouver exactement ce dont vous avez besoin via AllChinaBuy.',
  cat_shoes: 'Chaussures',
  cat_hoodies: 'Sweats / Pulls',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Vestes',
  cat_pants: 'Pantalons / Shorts',
  cat_headwear: 'Couvre-chefs',
  cat_sets: 'Ensembles',
  cat_underwear: 'Sous-vêtements',
  cat_jersey: 'Maillots',
  cat_accessories: 'Accessoires',
  cat_bags: 'Sacs',
  cat_belts: 'Ceintures',
  cat_perfumes: 'Parfums',
  cat_other: 'Autres Articles',
  cat_fashion: 'Mode',
  cat_streetwear: 'Streetwear',
  cat_sportswear: 'Sportswear',
  cat_electronics: 'Électronique',
  cat_home: 'Maison & Lifestyle',
  cat_popular: 'Trouvailles Populaires',

  featured_title: 'Ressources AllChinaBuy Spreadsheet en Vedette',
  featured_subtitle: 'Un aperçu organisé de produits, vendeurs et guides pour naviguer efficacement sur AllChinaBuy.',
  col_product: 'Produit',
  col_category: 'Catégorie',
  col_seller: 'Vendeur',
  col_qc: 'QC',
  col_guide: 'Guide',
  col_action: 'Action',
  action_view: 'Voir Détails',

  guides_title: 'Guides AllChinaBuy Populaires',
  guide_spreadsheet: 'Guide AllChinaBuy Spreadsheet',
  guide_review: 'Avis AllChinaBuy',
  guide_shipping: 'Coût d\'Expédition AllChinaBuy',
  guide_coupon: 'Coupon AllChinaBuy',
  guide_discount: 'Code de Réduction AllChinaBuy',
  guide_warehouse: 'Entrepôt AllChinaBuy',
  guide_legit: 'AllChinaBuy est-il Légitime?',
  guide_qc: 'Guide QC AllChinaBuy',
  guide_order: 'Comment Commander sur AllChinaBuy',
  guide_buying: 'Guide d\'Achat AllChinaBuy',
  guide_read: 'Lire le Guide',

  why_title: 'Pourquoi Utiliser Cette Ressource?',
  why_organized_title: 'Ressources Organisées',
  why_organized_desc: 'Trouvez des informations AllChinaBuy utiles en un seul endroit.',
  why_buying_title: 'Guides d\'Achat',
  why_buying_desc: 'Comprenez les produits, vendeurs, QC, expédition et commandes.',
  why_compare_title: 'Recherche Comparative',
  why_compare_desc: 'Comparez AllChinaBuy avec d\'autres plateformes d\'achat.',
  why_safety_title: 'Informations de Sécurité',
  why_safety_desc: 'Apprenez à identifier les risques et prendre des décisions éclairées.',

  compare_title: 'AllChinaBuy vs Autres Agents d\'Achat',
  compare_subtitle: 'Comparez les fonctionnalités clés entre AllChinaBuy et d\'autres plateformes d\'achat populaires.',
  compare_feature: 'Fonctionnalité',
  compare_allchinabuy: 'AllChinaBuy',
  compare_superbuy: 'Superbuy',
  compare_cssbuy: 'CSSBuy',
  compare_sugargoo: 'Sugargoo',
  compare_pandabuy: 'PandaBuy',
  compare_check: 'Vérifier la disponibilité actuelle',

  safety_title: 'Achetez Plus Intelligemment avec les Guides de Sécurité AllChinaBuy',
  safety_desc: 'Avant de passer toute commande, apprenez les pratiques de sécurité essentielles qui protègent votre argent, vos données et votre expérience d\'achat.',
  safety_seller_title: 'Recherche Vendeur',
  safety_seller_desc: 'Apprenez à vérifier les vendeurs avant de vous engager dans un achat.',
  safety_qc_title: 'Photos QC',
  safety_qc_desc: 'Comprenez pourquoi les photos de contrôle qualité sont importantes.',
  safety_link_title: 'Liens Suspects',
  safety_link_desc: 'Identifiez les signaux d\'alarme dans les listes de produits et pages vendeurs.',
  safety_payment_title: 'Sécurité des Paiements',
  safety_payment_desc: 'Utilisez des méthodes de paiement sécurisées et comprenez les protections acheteur.',
  safety_shipping_title: 'Risques d\'Expédition',
  safety_shipping_desc: 'Naviguez dans les douanes, assurances et considérations de livraison.',
  safety_refund_title: 'Remboursements',
  safety_refund_desc: 'Connaissez vos droits et les politiques plateforme avant d\'acheter.',

  faq_title: 'Questions Fréquemment Posées',
  faq_q1: 'Qu\'est-ce qu\'un AllChinaBuy Spreadsheet?',
  faq_a1: 'Un AllChinaBuy Spreadsheet est une collection organisée de liens produits, références vendeurs, guides d\'achat et conseils pour aider les acheteurs à naviguer efficacement sur la plateforme AllChinaBuy.',
  faq_q2: 'AllChinaBuy est-il un agent d\'achat légitime?',
  faq_a2: 'AllChinaBuy est une plateforme d\'agent d\'achat qui connecte les acheteurs internationaux avec des vendeurs chinois. Comme tous les agents d\'achat, la légitimité dépend de la qualité de service actuelle et des expériences utilisateurs.',
  faq_q3: 'Comment utiliser un AllChinaBuy Spreadsheet?',
  faq_a3: 'Commencez par parcourir les catégories de produits correspondant à votre recherche. Recherchez le vendeur, vérifiez les photos QC disponibles, examinez les coûts d\'expédition et suivez nos guides d\'achat.',
  faq_q4: 'Quelles options d\'expédition AllChinaBuy propose-t-il?',
  faq_a4: 'AllChinaBuy propose généralement plusieurs lignes d\'expédition incluant EMS, DHL, FedEx et divers services postaux. Les coûts varient selon la destination, le poids et la méthode choisie.',
  faq_q5: 'Existe-t-il des coupons ou codes de réduction AllChinaBuy?',
  faq_a5: 'La disponibilité des coupons change avec le temps. Certaines plateformes offrent des promotions saisonnières, des remises de parrainage ou des économies pour nouveaux utilisateurs.',
  faq_q6: 'Comment vérifier les photos QC sur AllChinaBuy?',
  faq_a6: 'Les photos de contrôle qualité sont généralement disponibles dans votre tableau de bord de commande après l\'arrivée des articles à l\'entrepôt. Demandez des photos QC détaillées avant l\'expédition.',
  faq_q7: 'Quel est le processus d\'entrepôt AllChinaBuy?',
  faq_a7: 'Après l\'achat, les vendeurs expédient les articles vers l\'entrepôt AllChinaBuy. Les articles sont inspectés, photographiés (QC) et stockés. Vous pouvez ensuite examiner, consolider et expédier votre colis.',
  faq_q8: 'Comment comparer AllChinaBuy avec d\'autres agents d\'achat?',
  faq_a8: 'Comparez sur la base des tarifs d\'expédition, frais de service, qualité des photos QC, réactivité du support client et avis utilisateurs. Notre section de comparaison offre un cadre structuré pour évaluer ces facteurs.',

  final_cta_title: 'Prêt à Explorer le AllChinaBuy Spreadsheet?',
  final_cta_desc: 'Parcourez des ressources organisées, des guides produits et des informations d\'achat utiles en un seul endroit.',
  final_cta_primary: 'Explorer AllChinaBuy Spreadsheet',
  final_cta_secondary: 'Voir Toutes les Catégories',

  ext_btn_main: 'AllChinaBuy Spreadsheet',
  ext_btn_buy: 'Acheter Maintenant',

  footer_disclaimer: 'Ce site fournit un contenu informatif indépendant et ne garantit pas la qualité des produits, le comportement des vendeurs, les résultats d\'expédition, les remboursements ou la performance de la plateforme. Les utilisateurs doivent vérifier les informations actuelles avant d\'acheter.',
  footer_about: 'À Propos',
  footer_policy: 'Politique Éditoriale',
  footer_contact: 'Contact',
  footer_privacy: 'Politique de Confidentialité',
  footer_terms: 'Conditions d\'Utilisation',
  footer_copyright: 'AllChinaBuy Spreadsheet. Ressource d\'information indépendante.',

  article_breadcrumb_home: 'Accueil',
  article_breadcrumb_article: 'Article',
  article_read_time: 'min de lecture',
  article_updated: 'Mis à jour',
  article_related: 'Ressources Connexes',
  article_back_home: 'Retour à l\'Accueil',
  article_author: 'Équipe de Recherche',
  article_share: 'Partager ce guide',
  article_toc: 'Table des Matières',
  article_intro: 'Introduction',
  article_conclusion: 'Conclusion',
  article_cta_text: 'Explorez plus de ressources AllChinaBuy et trouvez les meilleurs produits pour vos besoins.',
  article_cta_button: 'Parcourir Toutes les Ressources',
};